import React, { useRef } from 'react';
import { useObserver } from 'mobx-react-lite';
import { useStores } from '../../../store';
import { useReactToPrint } from 'react-to-print';
import { DownloadResume } from '../resume_output';

const Resume4 = () => {
  const { ResumeStore } = useStores();

  const resumeRef = useRef(null);

  const handleDownload = useReactToPrint({
    content: () => resumeRef.current,
  });

  return useObserver(() => (
    <>
   <DownloadResume onClick={handleDownload}/>
    <div className="max-w-4xl mx-[5%] my-10 bg-white shadow-lg rounded-lg overflow-hidden" ref={resumeRef}>
        <div className="bg-[#2C3E50] text-white p-6 flex justify-between items-center">
            <div>
            <h1 className="text-3xl font-extrabold">{ResumeStore?.resumeBuilder.personalDetails.firstName} {ResumeStore?.resumeBuilder.personalDetails.lastName}</h1>
            <p className="text-xl text-[#1abc9c]">{ResumeStore?.resumeBuilder.personalDetails.jobTitle}</p>
            </div>
            <div className="text-right">
            <p><strong>Phone:</strong> {ResumeStore?.resumeBuilder.personalDetails.phone}</p>
            <p><strong>Email:</strong> {ResumeStore?.resumeBuilder.personalDetails.email}</p>
            <p><strong>Address:</strong> {ResumeStore?.resumeBuilder.personalDetails.address}</p>
            </div>
        </div>
        <div className="p-6 flex">
            <div className="w-1/3 pr-6 border-r border-[#e0e0e0]">
            <div className="mb-6">
                <img 
                className="w-[100px] md:w-[200px] h-[100px] md:h-[200px] mx-auto rounded-full shadow-md mb-4" 
                src={ResumeStore?.resumeBuilder?.profile || 'https://images.unsplash.com/photo-1508341591423-4347099e1f19?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8bWVufGVufDB8fDB8fHww'} alt="Profile" />
            </div>
            <div className="mb-6">
                <h3 className="text-xl font-semibold text-[#2C3E50] border-b-2 border-[#2C3E50] pb-2">Skills</h3>
                <ul className="list-disc pl-4">
                {ResumeStore?.resumeBuilder.skills.map((skill, index) => (
                    <li key={index} className="mt-2">{skill}</li>
                ))}
                </ul>
            </div>
            <div className="mb-6">
                <h3 className="text-xl font-semibold text-[#2C3E50] border-b-2 border-[#2C3E50] pb-2">Interests</h3>
                <ul className="list-disc pl-4">
                {ResumeStore?.resumeBuilder.hobbies.map((hobby, index) => (
                    <li key={index} className="mt-2">{hobby}</li>
                ))}
                </ul>
            </div>
            </div>
            <div className="w-2/3 pl-6">
            <div className="mb-6">
                <h3 className="text-xl font-semibold text-[#2C3E50] border-b-2 border-[#2C3E50] pb-2">Profile</h3>
                <p className="mt-2">{ResumeStore?.resumeBuilder.profileSummary}</p>
            </div>
            <div className="mb-6">
                <h3 className="text-xl font-semibold text-[#2C3E50] border-b-2 border-[#2C3E50] pb-2">Experience</h3>
                {ResumeStore?.resumeBuilder.employementHistory.map((job, index) => (
                <div key={index} className="mb-4">
                    <p><strong>{job.jobTitle}</strong> | {job.company} | {job.startDate} - {job.endDate}</p>
                    <p>{job.description}</p>
                </div>
                ))}
            </div>
            <div className="mb-6">
                <h3 className="text-xl font-semibold text-[#2C3E50] border-b-2 border-[#2C3E50] pb-2">Education</h3>
                {ResumeStore?.resumeBuilder.education.map((edu, index) => (
                <div key={index} className="mb-4">
                    <p><strong>{edu.degree}</strong> | {edu.school} | {edu.startDate} - {edu.endDate}</p>
                    <p>{edu.description}</p>
                </div>
                ))}
            </div>
            </div>
        </div>
        </div>
    </>
  ));
}

export default Resume4;
